import { mapState } from 'vuex';
import themeToggle from "@/components/assets/themetoggle/index.vue";
import faseIdToggle from "@/components/assets/faceidtoggle/index.vue";
import settingToggle from './settingToggle/index.vue';

export default {
    name: 'settings',
    props: {
    },

    components : {
        faseIdToggle, themeToggle, settingToggle
    },

    data : function(){

        return {
            loading : false
        }

    },

    created(){

        /*this.core.settings.interface.getall().then(settings => {
            this.logotype = settings.logotype.value
        }).finally(() => {
            this.loading = false
        })*/

    },

    watch: {
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        settings : function(){
            var settings = {
                interface : [
                    {
                        component : themeToggle
                    },

                    {
                        action : this.interfacelocale,
                        view : 'button',
                        text : 'settings.interfacelocale'
                    },
                    
                ],

                account : [

                    {
                        text : 'labels.licence',
                        view : 'button',

                        route : '/features'
                    },

                    /*{
                        text : 'common.2901009',
                        view : 'button',

                        route : '/changepassword'
                    },*/

                    {
                        text : 'settings.bday',
                        view : 'button',

                        action : this.bday
                    },
                    {
                        text : 'settings.locale',
                        view : 'button',

                        action : this.locale
                    }/*,

                    {
                        component : faseIdToggle
                    }*/
                ],

                safe : [

                    {
                        text : 'settings.parentalPin',
                        view : 'button',
                        action : this.setPincode
                    }

                ],

                effects : [
                    {
                        component : settingToggle,
                        data : {
                            setting : 'interface.animatedBackground',
                            parentalDefControl : true
                        }
                    },
                    {
                        component : settingToggle,
                        data : {
                            setting : 'interface.emoji',
                            parentalDefControl : true
                        }
                    },
                    {
                        component : settingToggle,
                        data : {
                            setting : 'interface.particles',
                            parentalDefControl : true
                        }
                    },

                    {
                        component : settingToggle,
                        data : {
                            setting : 'interface.pastel',
                            parentalDefControl : true
                        }
                    },

                    
                ]
            }
            
            var rm = []

            if(this.core.user.info?.userinfo){
                if(this.core.user.info.userinfo.type === 0){

                    settings.account.push({
                        text : 'settings.removeuser',
                        view : 'button',
                        style : 'bad',
                        action : this.removeuser
                    })

                }

                if(!this.core.user.info.userinfo.emailconfirmed && this.core.user.info.userinfo.email && this.core.user.info.userinfo.email.indexOf('***') == -1){
                    settings.account.unshift({
                        text : 'settings.confirmemail',
                        view : 'button',
                        style : 'main',
                        action : this.confirmemail
                    })
                }

                if(!this.core.user.info.userinfo.phoneconfirmed && this.core.user.info.userinfo.phone && this.core.user.info.userinfo.phone.indexOf('***') == -1){
                     settings.account.unshift({
                        text : 'settings.confirmemail',
                        view : 'button',
                        style : 'main',
                        action : this.confirmphone
                    })
                }
            }

            

            _.each(settings, (sg, i) => {

                sg = _.filter(sg, r => {
                    if (r.features){
                        if(!this.core.user.checkFeatures(r.features)) return false
                    }

                    return true
                })

                settings[i] = sg


                if(!sg.length) {
                    rm.push(i)
                }

            })

            _.each(rm, (i) => {
                delete settings[i]
            })

            return settings
        }   


    }),

    methods : {
        action : function(item){
            if(item.action) item.action()

            if(item.route) this.$router.push(item.route).catch(e => {})
        },

        bday : function(){

            this.core.parental('settings', {}, () => {

                this.core.vueapi.bday({}, {
                    close : function(){}
                })

            }, () => {

                if(!this.core.user.info?.userinfo?.bday) return true
            })

            
        },

        interfacelocale : function(){

            this.core.vueapi.locale({
                onlyselect : true,
                available : ["en", "ru", "inherrit"],
                initial : this.core.settings.interface.get('interfacelocale').value
            }, {
                select : (loc) => {
                    this.core.settings.interface.set('interfacelocale', loc)

                    this.core.user.applyEnv()
                },
                close : function(){

                }
            })

        },

        locale : function(){

            this.core.parental('settings', {}, () => {

                this.core.vueapi.locale({}, {
                    close : function(){

                    }
                })

            })

        },

        setPincode : function(){

            this.core.parentalPincode(() => {

                this.core.vueapi.pincode('create').then(pin => {

                    localStorage['ppi'] = pin

                }).catch(e => {

                })
                
            }, "settings.pin.newpin", null, true)
        },

        removeuser : function(){

            this.core.parental('removeuser', {
			}, () => {

                this.$dialog.confirm(
                    this.$t('settings.removeuserquestion'), {
                    okText: this.$t('yes'),
                    cancelText : this.$t('no')
                })
        
                .then((dialog) => {

                    return this.$dialog.confirm(
                        this.$t('settings.removeuserquestion2'), {
                        okText: this.$t('yes'),
                        cancelText : this.$t('no')
                    })
            
                    .then((dialog) => {
                        return this.removeuserTotal()
                    })

                }).catch( e => {
                })

            }, null, null, true)

        },

        removeuserTotal : function(){
            this.core.promwrapper(this.core.api.user.remove(), { hideicons : true } ).then(() => {

                this.$dialog.alert(
                    this.$t('settings.removeusersorry'), {
                    okText: this.$t('app.okay')
                }).catch(e => {

                })

                this.core.user.signout().then(() => {
                    
                    this.core.api.clearCache()
                    this.core.api.invalidateStorageAll()
                    this.$store.commit('lastlogin','')

                    this.$router.push('/').catch(e => {})
                })

            }).catch(e => {
                console.log("E", e)
            
                this.$dialog.alert(
                    JSON.stringify(e), {
                    okText: this.$t('app.okay')
                }).catch(e => {

                })
            })
        },

        confirmemail : function(){

            this.core.parental('settings', {
			}, () => {

                this.core.promwrapper(this.core.api.user.confirmation.email.request(), { hideicons : true } ).then(() => {

                    this.$dialog.alert(
                        this.$t('settings.confirmemailsent'), {
                        okText: this.$t('app.okay')
                    }).catch(e => {

                    })
                    

                }).catch(e => {
                    console.log("E", e)
                
                    this.$dialog.alert(
                        JSON.stringify(e), {
                        okText: this.$t('app.okay')
                    }).catch(e => {

                    })
                })

            })

           
        },  

        confirmephone : function(){
            
        }
    },
}